import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Grid from '@mui/material/Grid'

import Header from 'src/components/Header'
import PartnerLogos from 'src/components/PartnerLogos'
import hero from 'src/assets/img/home-page-hero.jpg'

import { Page } from 'src/assets/theme/containers'
import { HeroContainer, Hero } from './styles'

/*
 * Frames the child components with a header, page etc.
 *
 * For unauthenticated users.
 */

export default class FrameUnauthenticated extends Component {
  static propTypes = {
    noRoutesToOtherPages: PropTypes.bool,
    showPartnerLogos: PropTypes.bool,
  }

  render() {
    const { noRoutesToOtherPages, showPartnerLogos } = this.props
    return (
      <>
        <Page>
          <Header noRoutesToOtherPages={noRoutesToOtherPages} />
          <HeroContainer>
            <Grid container>
              <Hero image={hero} />
            </Grid>
          </HeroContainer>
          <PartnerLogos showPartnerLogos={showPartnerLogos} />
        </Page>
        {this.props.children}
      </>
    )
  }
}

FrameUnauthenticated.propTypes = {
  children: PropTypes.node,
}
